import React from "react"
import GiftRegistryPasswordDrawerDesktop from "./PasswordDrawerDesktop"
import GiftRegistryPasswordDrawerMobile from "./PasswordDrawerMobile"
import { useCore } from "@hooks/useCore"
import { useMedia } from "@hooks/useMedia"

const GiftRegistryPasswordDrawer = ({ registry, setDrawerOff, setUnlockRegistry }) => {
  const {
    helpers: { ErrorBoundary },
  } = useCore()
  const { isBase } = useMedia()

  return (
    <ErrorBoundary>
      {isBase ? (
        <GiftRegistryPasswordDrawerMobile registry={registry} setDrawerOff={setDrawerOff} setUnlockRegistry={setUnlockRegistry} />
      ) : (
        <GiftRegistryPasswordDrawerDesktop registry={registry} setDrawerOff={setDrawerOff} setUnlockRegistry={setUnlockRegistry} />
      )}
    </ErrorBoundary>
  )
}

export default React.memo(GiftRegistryPasswordDrawer)
